import { render, staticRenderFns } from "./WeighedCategory.vue?vue&type=template&id=4fa5a948&scoped=true"
import script from "./WeighedCategory.vue?vue&type=script&lang=js"
export * from "./WeighedCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5a948",
  null
  
)

export default component.exports